import React from "react";

// export default function Input({ labelText, ...props }) {
//   return (
//     <label className="default_input">
//       {!!labelText && <span className="label">{labelText}</span>}
//       <div className="input_rapper">
//         <input type="text" className="input" {...props} />
//       </div>
//     </label>
//   );
// }
export default function Input({ labelText, isTextarea = false, ...props }) {
  return (
    <label className="default_input">
      {!!labelText && <span className="label">{labelText}</span>}
      <div className="input_rapper">
        {isTextarea ? (
          <textarea className="input" {...props} style={{ resize: 'none'}} />
        ) : (
            <input type="text" className="input" {...props} />
        )}
      </div>
    </label>
  );
}

function Select({ labelText, children, placeholder, ...props }) {
  return (
    <label className="default_input">
      {!!labelText && <span className="label">{labelText}</span>}
      <div className="input_rapper">
        <select type="text" className="input" {...props}>
          {placeholder ? (
            <option disabled selected value="">
              {placeholder}
            </option>
          ) : null}
          {children}
        </select>
      </div>
    </label>
  );
}

export { Select };
